import script from "./update-page.vue?vue&type=script&setup=true&lang=js"
export * from "./update-page.vue?vue&type=script&setup=true&lang=js"

import "./update-page.vue?vue&type=style&index=0&id=9646c566&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9646c566"]])

export default __exports__